import { NgModule } from '@angular/core';
import {
  MatToolbarModule,
  MatMenuModule,
  MatSidenavModule,
  MatExpansionModule,
  MatButtonModule,
  MatIconModule,
  MatListModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatPaginatorModule,
  MatCardModule,
  MatInputModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatFormFieldModule,
  MatSelectModule,
  MatSnackBarModule,
  MatDialogModule,
  MatTabsModule,
  MatRadioModule,
  MatSlideToggleModule,
  MatBadgeModule,
  MatCheckboxModule,
  MatGridListModule,
  MatAutocompleteModule,
  MatTreeModule
} from '@angular/material';




const Material = [
  MatToolbarModule,
  MatMenuModule,
  MatSidenavModule,
  MatExpansionModule,
  MatButtonModule,
  MatIconModule,
  MatListModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatPaginatorModule,
  MatCardModule,
  MatInputModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatFormFieldModule,
  MatSelectModule,
  MatSnackBarModule,
  MatDialogModule,
  MatTabsModule,
  MatRadioModule,
  MatSlideToggleModule,
  MatBadgeModule,
  MatCheckboxModule,
  MatGridListModule,
  MatAutocompleteModule,
  MatTreeModule
]

@NgModule({
  imports: [Material],
  exports: [Material]
})
export class CustomMaterialModule { }